<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 500px">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S302使用者密碼變更-編輯</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td width="40%">帳號</td>
                  <td width="60%">
                    <input type="text" :disabled="!!LoginInfo" v-model="form.id" />
                  </td>
                </tr>
                <tr>
                  <td height="43"><font color="#FF0000">*</font>舊密碼</td>
                  <td>
                    <input type="password" v-model="form.idtoken" />
                  </td>
                </tr>
                <tr>
                  <td><font color="#FF0000">*</font>新密碼</td>
                  <td>
                    <input
                      placeholder=""
                      type="password"
                      v-model="form.idtoken2"
                    />
                    <p>
                      <font color="#FF0000"
                        >8位以上英數字，須含大小寫英文及特殊符號</font
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td><font color="#FF0000">*</font>新密碼確認</td>
                  <td>
                    <input
                      placeholder="所輸入密碼須與新密碼相同"
                      type="password"
                      v-model="form.idtoken3"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          title="密碼變更須重新登入"
                          type="submit"
                          class="btn"
                          value="確認變更"
                          @click="btnidtokenChange()"
                        />
                      </span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <div class="information">
          <div class="active">
            <div class="table_scroll2"></div>
          </div>
        </div>
      </div>
    </div>
    <CyFooter />

    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { getMenuIndex } from "@/config/util.js";
import { S302_Modify } from "@/service/api.js";

export default {
  name: "S302",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S302",
        ServiceUnit: "CY",
        isForceLoginOut : false,
      },
      LoginInfo : sessionStorage.getItem("LoginInfo"),
      form: {
        id: "",
        idtoken: "",
        idtoken2: "",
        idtoken3: "",
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
  },
  methods: {
    verification: function () {
      const self = this;
      let errorMsg = [];
      let pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
      if (self.form.idtoken === "") {
        errorMsg.push("請輸入舊密碼");
      }
      if (self.form.idtoken2 === "") {
        errorMsg.push("請輸入新密碼");
      } else {
        if (self.form.idtoken2 === self.form.idtoken) {
          errorMsg.push("新密碼不得與原密碼相同");
        }
        if (!pattern.test(self.form.idtoken2)) {
          errorMsg.push("密碼須為8位以上英數字，且含大小寫英文及特殊符號");
        }
      }
      if (self.form.idtoken3 === "") {
        errorMsg.push("請輸入新密碼確認");
      } else {
        if (self.form.idtoken2 != self.form.idtoken3) {
          errorMsg.push("新密碼確認與新密碼不符");
        }
      }
      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        return false;
      } else {
        return true;
      }
    },
    btnidtokenChange: function () {
      const self = this;
      if (!self.verification()) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      } else {
        let formData = {
          ServiceUnit: self.pageData.ServiceUnit,
          account: self.form.id,
          oldidtoken: self.form.idtoken,
          newidtoken: self.form.idtoken2,
          chkidtoken: self.form.idtoken3,
          LogInfo:{
            Id:self.form.id,
            PrgCode:"S302",
            ActCd:"確認變更",
            ServiceUnit:"PDIS",
            Token: "",
          }
        };
        S302_Modify(formData).then((rData) => {
          if (rData.returnObject.success) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["修改完成"];
            self.Alert.BtnConfirm = () => {
               self.Alert.show = false;
              location.href = "/PdpsCli/BackStage/CY/Login";
            }
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [rData.returnObject.message];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
  },
  created(){
    const self = this;
    self.form.id = self.LoginInfo ? JSON.parse(self.LoginInfo).id : "";
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    // if (self.pageData.MenuIndex === null) {
    //   self.Alert.show = true;
    //   self.Alert.title = "訊息";
    //   self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
    //   self.Alert.BtnConfirm = () => {
    //     self.Alert.show = false;
    //     self.$router.go(-1);
    //   };
    // }
  }
};
</script>

<style scoped src="@/assets/css/Cy.css" />
